import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCall } from "../../utils/api";

const initialState = {
  summary: null,
  summaryStatus: "idle",
  interactions: [],
  interactionsStatus: "idle",
  topUsers: null,
  topUsersStatus: "idle",
  error: "",
};

export const getCardDiscoverySummary = createAsyncThunk(
  "cardDiscovery/getSummary",
  async ({ start_date, end_date } = {}) => {
    try {
      const params = [];
      if (start_date) params.push(`start_date=${start_date}`);
      if (end_date) params.push(`end_date=${end_date}`);
      let url = `/admin/v1/card-discovery/summary`;
      if (params.length > 0) url += `?${params.join("&")}`;

      const response = await getCall(url, false);
      return await response;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const getCardDiscoveryInteractions = createAsyncThunk(
  "cardDiscovery/getInteractions",
  async ({ page = 1, per_page = 50, action = "", card_id = "", category_id = "", start_date = "", end_date = "", date = "" } = {}) => {
    try {
      const params = new URLSearchParams({ page, per_page });
      if (action) params.append("action", action);
      if (card_id) params.append("card_id", card_id);
      if (category_id) params.append("category_id", category_id);
      if (start_date) params.append("start_date", start_date);
      if (end_date) params.append("end_date", end_date);
      if (date) params.append("date", date);

      const response = await getCall(`/admin/v1/card-discovery/interactions?${params}`, false);
      return await response;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

export const getCardDiscoveryTopUsers = createAsyncThunk(
  "cardDiscovery/getTopUsers",
  async ({ start_date, end_date, limit = 50 } = {}) => {
    try {
      const params = new URLSearchParams({ limit });
      if (start_date) params.append("start_date", start_date);
      if (end_date) params.append("end_date", end_date);

      const response = await getCall(`/admin/v1/card-discovery/top-users?${params}`, false);
      return await response;
    } catch (error) {
      return Promise?.reject(error);
    }
  }
);

const cardDiscoverySlice = createSlice({
  name: "cardDiscovery",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Get summary
      .addCase(getCardDiscoverySummary.pending, (state) => {
        state.summaryStatus = "loading";
      })
      .addCase(getCardDiscoverySummary.fulfilled, (state, action) => {
        state.summaryStatus = "succeeded";
        console.log('[CardDiscovery] Summary payload:', JSON.stringify(action.payload));
        state.summary = action.payload?.data;
      })
      .addCase(getCardDiscoverySummary.rejected, (state, action) => {
        state.summaryStatus = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      // Get interactions
      .addCase(getCardDiscoveryInteractions.pending, (state) => {
        state.interactionsStatus = "loading";
      })
      .addCase(getCardDiscoveryInteractions.fulfilled, (state, action) => {
        state.interactionsStatus = "succeeded";
        // ResponseHelper wraps paginator in data: { current_page, data: [...], per_page, total, last_page, ... }
        const paginated = action.payload?.data;
        state.interactions = {
          data: paginated?.data || [],
          meta: {
            current_page: paginated?.current_page,
            last_page: paginated?.last_page,
            per_page: paginated?.per_page,
            total: paginated?.total,
          },
        };
      })
      .addCase(getCardDiscoveryInteractions.rejected, (state, action) => {
        state.interactionsStatus = "failed";
        state.error = action.error.message || "An unknown error occurred";
      })
      // Get top users
      .addCase(getCardDiscoveryTopUsers.pending, (state) => {
        state.topUsersStatus = "loading";
      })
      .addCase(getCardDiscoveryTopUsers.fulfilled, (state, action) => {
        state.topUsersStatus = "succeeded";
        state.topUsers = action.payload?.data;
      })
      .addCase(getCardDiscoveryTopUsers.rejected, (state, action) => {
        state.topUsersStatus = "failed";
        state.error = action.error.message || "An unknown error occurred";
      });
  },
});

export default cardDiscoverySlice.reducer;
